import { upgradeRequestAllowedRoles } from 'src/components/upgrade-request-popup/UpgradeRequestPopup';
import { OrganizationApiResponseWithPopulatedPlan } from 'src/types/organization';
import { TotalInteractionCountApiResponse } from 'src/types/overview';
import { UpgradeRequestFormFields } from 'src/types/upgradeRequest';
import { UserApiResponse } from 'src/types/user';

export function checkUpgradeRequestButtonVisibilityAfterFetchingUsers(
  usersWithUserRole: UserApiResponse[],
  combinedUsersAdminRole: UserApiResponse[],
  userInteractionCount: number,
  maximumInteractionLimit: number,
): boolean {
  return (
    userInteractionCount >= maximumInteractionLimit &&
    (usersWithUserRole.length > 0 || combinedUsersAdminRole.length > 0)
  );
}

export function getCombinedNotifyUserList(
  userSelectedValues: UpgradeRequestFormFields,
  allUsersWithUserRole: UserApiResponse[],
  allUsersWithAdminRole: UserApiResponse[],
): UserApiResponse[] {
  const combinedNotifyUserList: UserApiResponse[] = [];

  if (userSelectedValues.isNotifyAdmin) {
    combinedNotifyUserList.push(...allUsersWithAdminRole);
  }

  if (userSelectedValues.notifyUsers.length > 0) {
    const usersMap = new Map(
      allUsersWithUserRole.map((user) => [user.email, user]),
    );

    userSelectedValues.notifyUsers.forEach((email) => {
      const currentUserDetails = usersMap.get(email);

      if (currentUserDetails) {
        combinedNotifyUserList.push(currentUserDetails);
      }
    });
  }

  return combinedNotifyUserList;
}

export function validateUpgradeRequest(
  userSelectedValues: UpgradeRequestFormFields,
): boolean {
  return (
    userSelectedValues.notifyUsers.length > 0 ||
    userSelectedValues.isNotifyAdmin
  );
}

export function checkUpgradeRequestButtonVisibilityBeforeFetchingUsers(
  organizationDetails: OrganizationApiResponseWithPopulatedPlan,
  userDetails: UserApiResponse,
  userInteractionResponse: TotalInteractionCountApiResponse,
): boolean {
  if (!organizationDetails || !userDetails) {
    return false;
  }

  if (!upgradeRequestAllowedRoles.includes(userDetails.role)) {
    return false;
  }

  if (!organizationDetails.planId) {
    return false;
  }

  const maximumInteractionLimit =
    organizationDetails.planId.monthlyInteractionLimitPerUser;

  if (userInteractionResponse.count < maximumInteractionLimit) {
    return false;
  }

  return true;
}
